import {
  getErasmusCategory,
  getLatestErasmusPost
} from "../api/wordpressErasmus.api";

const stripHtml = value => {
  if (!value) {
    return "";
  }

  const document = new DOMParser().parseFromString(value, "text/html");

  return document.body.textContent?.trim() ?? "";
};

const getImagesFromContent = html => {
  if (!html) {
    return [];
  }

  const document = new DOMParser().parseFromString(html, "text/html");

  return Array.from(document.querySelectorAll("img"))
    .map(image => image.getAttribute("src"))
    .filter(
      src =>
        src &&
        src.includes("/uploads/") &&
        !src.includes(".svg") &&
        !src.startsWith("data:image")
    );
};

const getRandomImage = images => {
  if (!images.length) {
    return null;
  }

  return images[Math.floor(Math.random() * images.length)];
};

export const getLatestErasmusNews = async ({ signal } = {}) => {
  const category = await getErasmusCategory({ signal });

  if (!category) {
    return null;
  }

  const post = await getLatestErasmusPost(category.id, { signal });

  if (!post) {
    return null;
  }

  const images = getImagesFromContent(post.content?.rendered);

  return {
    id: post.id,
    title: stripHtml(post.title?.rendered),
    excerpt: stripHtml(post.excerpt?.rendered),
    url: post.link,
    image: getRandomImage(images),
    date: post.date
  };
};